var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourceCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0m219.428571 0l585.142858 0q219.428571 0 219.428571 219.428571l0 585.142858q0 219.428571-219.428571 219.428571l-585.142858 0q-219.428571 0-219.428571-219.428571l0-585.142858q0-219.428571 219.428571-219.428571Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M502.857143 248.923429l-201.234286 109.129142a17.261714 17.261714 0 0 0 0 30.354286L512.768 502.857143l209.609143-113.627429a17.261714 17.261714 0 0 0 0-30.354285l-202.843429-109.915429a17.462857 17.462857 0 0 0-16.603428 0l-0.073143-0.036571z m-237.842286 415.451428l203.062857 110.628572A17.334857 17.334857 0 0 0 493.714286 759.826286V529.097143l-212.077715-115.547429a17.334857 17.334857 0 0 0-25.636571 15.213715v220.397714c0 6.345143 3.437714 12.196571 9.014857 15.250286v-0.036572zM530.285714 529.664v230.034286c0 6.162286 3.2 11.849143 8.466286 14.994285a17.261714 17.261714 0 0 0 17.133714 0.329143l203.062857-111.140571a17.408 17.408 0 0 0 9.051429-15.323429V428.836571a17.408 17.408 0 0 0-8.484571-14.976 17.261714 17.261714 0 0 0-17.152-0.292571L530.285714 529.664z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceCenter);
export default __webpack_public_path__ + "static/media/resource-center.bc1d63ba4d781d1777fe5225d048c1cc.svg";
export { ForwardRef as ReactComponent };